<div class="bg-white rounded-lg shadow-sm p-6 border border-gray-200 h-full">
  <!-- Sync Date Info Section -->
  <div
    *ngIf="syncDate"
    class="mb-4 px-4 py-2 rounded-lg border bg-gray-50 border-gray-200"
  >
    <div class="flex items-center space-x-2">
      <mat-icon class="text-sm text-blue-600">info</mat-icon>
      <span class="text-sm text-gray-700">
        Data retrieved from official government sources as of
        <span class="font-semibold">{{ formattedSyncDate }}</span
        >.
      </span>
    </div>
  </div>

  <div class="flex items-center mb-5">
    <div
      class="w-5 h-5 rounded-full mr-4 relative"
      [ngClass]="hasActiveFCRA ? 'bg-green-500' : 'bg-red-500'"
    >
      <div
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full"
      ></div>
    </div>
    <h2 class="text-xl font-poppins font-semibold text-[#E53935] mb-0">
      FCRA Compliance
    </h2>
  </div>

  <div class="space-y-3">
    <div
      class="flex justify-between items-center py-3 border-b border-gray-100"
    >
      <span class="font-poppins font-medium text-[#4B4B4B]"
        >Registration Status</span
      >
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="
          hasActiveFCRA
            ? 'bg-green-100 text-green-800'
            : 'bg-red-100 text-red-800'
        "
      >
        {{ hasActiveFCRA ? "ACTIVE" : "NOT FOUND" }}
      </span>
    </div>

    <div
      class="flex justify-between items-center py-3 border-b border-gray-100"
    >
      <span class="font-poppins font-medium text-[#4B4B4B]">FCRA Number</span>
      <span class="font-poppins text-[#0E1116]">{{
        fcraRecord?.fcraRegistrationNumber || "N/A"
      }}</span>
    </div>

    <div
      class="flex justify-between items-center py-3 border-b border-gray-100"
    >
      <span class="font-poppins font-medium text-[#4B4B4B]"
        >Validity Period</span
      >
      <span class="font-poppins text-[#0E1116]">
        {{ fcraRecord?.validityFromDate || "N/A" }} to
        {{ fcraRecord?.validityToDate || "N/A" }}
      </span>
    </div>

    <div
      *ngIf="validityDetails"
      class="flex justify-between items-center py-3 border-b border-gray-100"
    >
      <span class="font-poppins font-medium text-[#4B4B4B]">Expires</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="validityDetails.status.className"
      >
        {{ fcraRecord?.validityToDate }} ({{ timeRemaining?.text }})
      </span>
    </div>

    <div class="flex justify-between items-center py-3">
      <span class="font-poppins font-medium text-[#4B4B4B]">Address Match</span>
      <span
        class="px-3 py-1 rounded-full text-xs font-poppins font-semibold"
        [ngClass]="
          hasActiveFCRA
            ? 'bg-green-100 text-green-800'
            : 'bg-red-100 text-red-800'
        "
      >
        {{ hasActiveFCRA ? "VERIFIED" : "NOT VERIFIED" }}
      </span>
    </div>

    <div
      *ngIf="
        hasActiveFCRA &&
        timeRemaining &&
        timeRemaining.months < 12 &&
        !timeRemaining.isExpired
      "
      class="mt-4 p-3 rounded-lg text-sm font-poppins"
      [ngClass]="alertClass"
    >
      <strong>{{ alertMessage }}</strong>
    </div>

    <div
      *ngIf="timeRemaining?.isExpired"
      class="mt-4 p-3 bg-red-50 rounded-lg text-red-800 text-sm font-poppins"
    >
      <strong>EXPIRED:</strong> FCRA registration has expired. Immediate action
      required to restore foreign funding eligibility.
    </div>
  </div>
</div>
